import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Lote } from '../../../models/lote';
import { Pagination } from '../../../models/pagination';
import { LoteService } from '../../../services/lote.service';
import { BsModalRef } from 'ngx-bootstrap';
import * as moment from 'moment';
import { ParametroService } from '../../../services/parametro.service';
import { resolve } from 'url';



@Component({
	selector: 'app-lote-modal',
	templateUrl: './lote-modal.component.html',
	styleUrls: ['./lote-modal.component.css'],
	providers: [LoteService, ParametroService]
})
export class LoteModalComponent implements OnInit {

	@Output() sendLote = new EventEmitter();
	// @Output() onSelectedRow = new EventEmitter();
	// @Input() qs = "";
	// @Input() numero_decimales: number = 2;
	@Input() producto_id: String;
	public lotes: Array<Lote> = [];
	public selectedRow: Number;
	public lote;
	public pagination: Pagination;
	public loading = false;
	public format_decimal: String;
	public dias_restantes;
	public dia_caducidad_lote:number;
	constructor(
		public LoteService: LoteService,
		public bsModalRef: BsModalRef,
		public parametroService: ParametroService,
	) {
		this.lotes = [];
		// this.lote = new Lote();
		this.pagination = new Pagination();
		this.dia_caducidad_lote = 0;
	}

	ngOnInit() {
		// let digitos = "";
		// for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
		// this.format_decimal = "0,0." + digitos
		let p1 = this.getLotes();
		let p2 = this.getParamDiaLote();
		this.loading  = true;
		Promise.all([p1,p2]).then(
			res => this.loading = false,
			err => this.loading = false
		);
	}

	getParamDiaLote(){
        // VALORES RESPONSE: SI, NO
        return new Promise((resolve, reject) => {
            let dia_lote_id = 24;
            this.parametroService.getById(dia_lote_id).subscribe(
                res => {
                    this.dia_caducidad_lote = parseInt(res.valor);
                    resolve();
                },
                err => {
                    this.dia_caducidad_lote = 0;
                    reject(err);
                }
            );
        });
	}
	
	getLotes(qs = "") {
		// this.loading = true;
		return new Promise((resolve,reject)=>{
			this.LoteService.getAllbyInventario("?page=" + this.pagination.current_page + "&per_page=10" + qs + "&producto_id=" + this.producto_id).subscribe(
				res => {
					// this.loading = false;
					this.lotes = res.data;
					
					this.pagination.current_page = res.current_page;
					this.pagination.from = res.from;
					this.pagination.to = res.to;
					this.pagination.total = res.total;
					this.pagination.last_page = res.last_page;
					this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
					this.pagination.prev_disabled = this.pagination.current_page === 1;
					resolve();
				},
				err => {
					// this.loading = false;
					this.lotes = [];
					reject(err);
				}
			);
		});
		
	}

	getComprasBySearch(text) {
		let qs = "&codigo=" + text;
		this.pagination.current_page = 1;
		this.getLotes(qs);
	}

	

	getDiasRestantes(lote: Lote) {
		
		let fecha1 = moment(lote.fecha_elaboracion);
		let fecha2 = moment(lote.fecha_expiracion);
		this.dias_restantes = fecha2.diff(fecha1, 'days');
		return this.dias_restantes;
	}

	getLotesBySearch(text) {
		let qs = "&codigo=" + text;
		this.pagination.current_page = 1;
		this.getLotes(qs);
	}


	onSelectRow(lote, i) {
		//Asignacion de fila
		this.selectedRow = i;
		//Asignacion de usuario
		this.lote = lote;
	}

	onDBLClick(usuario, i) {
		this.onSelectRow(usuario, i);
		this.onSubmit();
	}

	onSubmit() {
		//si existe lote seleccionado
		if (this.lote) {
			//envía de objecto usuario
			this.sendLote.emit(this.lote);
			this.bsModalRef.hide();
		} else {
			//Cierre de modal o componente
			this.bsModalRef.hide();
		}


	}

	next() {
		this.pagination.current_page++;
		this.getLotes();
	}

	prev() {
		this.pagination.current_page--;
		this.getLotes();
	}

	first() {
		this.pagination.current_page = 1;
		this.getLotes();
	}

	last() {
		this.pagination.current_page = this.pagination.last_page;
		this.getLotes();
	}

	get formatDecimal() {
		return this.format_decimal;
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/lote-modal/lote-modal.component.ts